const MAIN_PATH = '/users';
export const USERS = MAIN_PATH;
export const USER_DETAIL = MAIN_PATH;
export const ROUTES = {
  USERS,
  USER_DETAIL,
};
